import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { NoticiaDetalhesPage } from "../noticia-detalhes/noticia-detalhes.page";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CommonModule } from "@angular/common";
import { ImagePipe } from "src/app/pipes/image/image";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { TranslateModule } from "@ngx-translate/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { SemRegistroComponent } from "../sem-registro/sem-registro";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";

@Component({
  selector: "app-list-image-accordion",
  templateUrl: "./list-image-accordion.component.html",
  styleUrls: ["list-image-accordion.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ImagePipe,
    DateFormatPipe,
    TranslateModule,
    ReactiveFormsModule,
    SemRegistroComponent,
    NomenclaturaPipe
  ],
})
export class ListImageAccordionComponent implements OnInit, OnChanges {
  @Input() noticiasAno: any;
  @Input() texto: any;
  @Input() dateFilter: any;
  @Output() dateChange = new EventEmitter<string>();
  validations_form: FormGroup;

  constructor(
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.validations_form = this.formBuilder.group({
      dataInicio: new FormControl(this.dateFilter, Validators.nullValidator),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["dateFilter"] && this.validations_form) {
      this.validations_form.patchValue({
        dataInicio: format(new Date(this.dateFilter), "yyyy-MM-dd"),
      });
    }
  }

  async abrirNoticia(idNoticia: any) {
    const modalPage = await this.modalCtrl.create({
      component: NoticiaDetalhesPage,
      componentProps: {
        id: idNoticia,
      },
    });

    modalPage.present();
  }

  setDate(date: any) {
    this.dateChange.emit(date);
  }

  onSubmit(form: any) {
    if (form.dataInicio) {
      this.validations_form.patchValue({ dataInicio: form.dataInicio });
      this.setDate(form.dataInicio);
    }

    this.modalCtrl.dismiss(form);
  }
}
